/* eslint-disable new-cap */
import {FormControlMixin} from 'extensions/ui-mixins';
import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {createRef, ref} from 'lit/directives/ref.js';
import stylesheet from './x-file-uploader-input.scss?as=stylesheet';

export class FileUploaderInputComponent extends FormControlMixin(LitElement) {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			_names: {
				state: true,
				type: String
			}
		};
	}

	/**
	 * @type {import('lit/directives/ref').Ref<HTMLInputElement>}
	 */
	inputRef = createRef();

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this._names = '';

		// Bind events
		this.addEventListener('change', (e) => this._handleUpload(e));
	}

	/**
	 * @param {CustomEvent<import('extensions/ui-components/x-file-uploader/types').FileUploaderChangeEventData[]>} e
	 */
	_handleUpload (e) {
		// Handle only file uploader events
		if (e.target.nodeName === 'X-FILE-UPLOADER') {
			const {names, urls} = e.detail?.reduce(
				(output, photo) => {
					return {
						names: output.names.concat([photo.name]),
						urls: output.urls.concat([photo.url])
					};
				},
				{
					names: [],
					urls: []
				}
			);

			this._names = names.join(', ');
			this.value = urls.join(',');
		}
	}

	handleClearButton () {
		this.value = '';
	}

	renderValueState () {
		const classes = {
			input: true,
			'is--hidden': !this.value
		};

		return html`
			<input class="${classMap(classes)}" type="text" readonly value="${this._names || this.value}" />
			<button @click="${this.handleClearButton}" class="clear-button" aria-label="Clear uploaded file(s)" title="Clear uploaded file(s)"><span class="clear-icon"></span></button>
		`;
	}

	render () {
		return html`
			<div class="container">
				<input ${ref(this.inputRef)} type="text" class="input is--hidden" name="${this.name}" value="${this.value}" ?disabled="${this.disabled}" ?required="${this.required}" />
				${this.value ? this.renderValueState() : nothing}
				${this.value ? nothing : html`<slot></slot>`}
			</div>
		`;
	}
};

defineCustomElement('x-file-uploader-input', FileUploaderInputComponent);
